module.exports = __webpack_public_path__ + "static/media/addLinkIcon.081d82ea.svg";